<template>
    <div class="compare-patent-loading pa-w-1/2">
        <CompareHeader :side="side" />
        <div class="pa-h-[64px] pa-border-b pa-border-solid pa-border-gray-40 pa-px-2 pa-pr-[40px] pa-pt-2.5 pa-shadow-[0px_1px_2px_0px_rgba(0,0,0,0.06)]">
            <span class="pa-block pa-h-4 pa-w-[128px] pa-rounded pa-bg-green-75" />
            <span class="pa-mt-1 pa-block pa-h-4 pa-rounded pa-bg-gray-30" />
        </div>
        <div class="pa-bg-gray-20">
            <MenuTabsScrollable
                currentTab="CLMS"
                :defaultTabs="defaultTabs"
            />
        </div>
        <div v-if="isSourceCustom" class="pa-pt-[180px] pa-text-center">
            <PtIcon icon="SolidLoadingBars" class="!pa-text-[48px]" />
        </div>
        <CompareLoadingContent v-else class="pa-pt-[108px]" />
    </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';
import CompareHeader from '@/components/compare-components/compare-header/CompareHeader.vue';
import CompareLoadingContent from '@/components/compare-components/compare-loading-content/CompareLoadingContent.vue';
import MenuTabsScrollable from 'library-@/components/MenuTabs/MenuTabsScrollable.vue';
import { useI18n } from '@/composables/use-i18n';
import { Icon as PtIcon } from 'patsnap-biz';
import { useCompareUrlState } from '@/composables/use-compare-url-state';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';

const { t } = useI18n();

const { side } = defineProps({
    side: {
        type: String,
        default: 'left',
    },
});

const { isSourceCustom } = useCompareUrlState();

// 假的tab
const tabsLabel = {
    ABST: t('patent-view.ABST'),
    CLMS: t('patent-view.CLMS'),
    DESC: t('patent-view.DESC'),
    IMAGES: t('patent-view.images'),
    PDF: t('patent-view.dual.pdfSource'),
};
const defaultTabs = ['ABST', 'CLMS', 'DESC', 'IMAGES', 'PDF'].map(item => {
    return {
        label: tabsLabel[item],
        key: item,
        hasAcl: true,
    };
});
</script>

<style lang="scss">

</style>
